import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AvailableLangCodes } from './types/languages.type';

@Component({
	selector: 'nr-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	standalone: false,
})
export class AppComponent {
	private translateService = inject(TranslateService);

	constructor() {
		//? Lingue disponibili in ordine crescente di importanza
		this.translateService.addLangs(AvailableLangCodes);
	}
}
